import { render, staticRenderFns } from "./AddProfile.vue?vue&type=template&id=49fd65b8&scoped=true"
import script from "./AddProfile.vue?vue&type=script&lang=js"
export * from "./AddProfile.vue?vue&type=script&lang=js"
import style0 from "./AddProfile.vue?vue&type=style&index=0&id=49fd65b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fd65b8",
  null
  
)

export default component.exports